const allNames = (obj) => Object.getOwnPropertyNames(obj)
    .concat(Object.getOwnPropertySymbols(obj));
export default allNames;
